<template>
  <div id="app" :style="{'min-width': ($route.meta.single && isSinglePage) ? '100%' : '1200px' }">
    <el-container v-if="!isSinglePage && !$route.meta.single">
      <header class="header" height="500px">
        <div class="header__top-line">
          <div class="left">
            <div class="logo">福建科技特派员服务云平台</div>
          </div>
          <div class="right">
            <city-portal-list />
            <div class="card" @click="search">
              <div class="more">
                <span
                  ><i
                    class="el-icon-search"
                    style="margin-right: 5px"
                  />高级检索</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="header__carousel">
          <el-carousel trigger="click" height="340px" arrow="never">
            <el-carousel-item v-for="item in bannerList" :key="item.name">
              <div :style="'height: 340px;'">
                <img
                  :src="item.imgUrl"
                  @click="goBanner(item.link)"
                  :style="
                    'cursor:' +
                    (item.link && item.link != '' ? 'pointer' : 'default')
                  "
                  style="
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-flow: column nowrap;
                    align-items: center;
                    justify-content: center;
                  "
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div style="background-color: #1ca868">
          <div class="header__menu">
            <el-menu
              ref="menu"
              :default-active="routeParentPath || routeName"
              @select="menuSelect"
              mode="horizontal"
              background-color="#1ca868"
              text-color="#fff"
              active-text-color="#1ca868"
            >
              <el-menu-item
                v-for="menu in menuList"
                :key="menu.colId"
                :index="menu.colPath"
                >{{ menu.colName }}</el-menu-item
              >
            </el-menu>
          </div>
        </div>
      </header>
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </el-main>
      <el-footer class="footer" height="90px">
        <div>
          <span>主管部门：福建省科学技术厅</span>
          <span>运维单位：福建省农业科学院数字农业研究所</span>
        </div>
        <div>
          <span style="cursor: pointer" @click="goTo">{{ icpInfo }}</span>
          <span>维护电话：0591-87869374</span>
          <span style="margin-left:5px">总访问量：{{ countAll }}人次</span>
        </div>
      </el-footer>
    </el-container>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import CityPortalList from '@/components/CityPortalList'
import { mapGetters, mapMutations, mapActions } from "vuex";
import { queryAllBanners } from "@/api/banner";
import oss from "@/mixins/oss";
import visitRecordMixin from "@/mixins/visitRecord";
import { countAll } from "@/api/config";
import { domainConfigFromNode } from '@/api/node'
import { getSessionInfo, setSessionInfo } from '@/utils/sessionStorage'
import { isAbsPath } from '@/utils/regex';

export default {
  mixins: [oss, visitRecordMixin],
  components: {
    CityPortalList
  },
  data() {
    return {
      bannerList: [],
      searchKey: "",
      icpInfo: "闽ICP备20005168号-3",
      countAll: 0,
      isSinglePage: false
    };
  },
  computed: {
    ...mapGetters(["routeName", "menuList", "routeParentPath"]),
  },
  created() {
    const curHref = window.location.href
    this.isSinglePage = curHref.indexOf('/certInfo/') != -1
  },
  mounted() {
    if (!this.$route.meta.single && !this.isSinglePage) {
      let host = window.location.host;
      let icpInfo = getSessionInfo(host)
      icpInfo = typeof icpInfo == 'string' ? icpInfo : icpInfo[host]
      if (icpInfo) {
        this.icpInfo = icpInfo
      } else {
        domainConfigFromNode({
          cfgKey: host
        }).then(res => {
          if(!res) {
            res = '闽ICP备20005168号-3'
          }
          setSessionInfo(host, res)
          this.icpInfo = res
        })
      }
      this.queryAllBanners();
      if (this.routeName == 'home') {
        this.pageVisitRecord(this.SITESTR + "0902da0561000000", "", "平台首页" , "2001", "1");
        this.queryAll(this.SITE || 'main')
      } else {
        this.queryAll(this.SITE || 'main').then(() => {
          this.menuSelect(this.routeName)
        })
      }
      countAll().then((res) => {
        this.countAll = res;
      })
    }
  },
  methods: {
    ...mapActions(['queryAll']),
    ...mapMutations(["setCurrentRouteName", "setSearchKey", "setCurrentMenu"]),
    queryAllBanners() {
      let bannerList = [];
      queryAllBanners({ status: 1 })
        .then((res) => {
          bannerList = res;
          return Promise.all(
            res.map((item) => {
              if (!this.hasHttp(item.filePath)) {
                return this.ossSignatureUrl({
                  objectName: item.filePath,
                });
              } else {
                return item.filePath;
              }
            })
          );
        })
        .then((res) => {
          this.bannerList = bannerList.map((item, i) => {
            return {
              ...item,
              imgUrl: res[i],
            };
          });
          return this.$nextTick();
        });
    },
    toWebSite(url) {
      window.open(url, "_blank");
    },
    menuSelect(name) {
      let curMenu = this.menuList.filter((item) => item.colPath == name || item.colPath == this.routeParentPath);
      if (curMenu && curMenu.length > 0) {
        this.setCurrentMenu(curMenu[0]);
      }
      if (name === "portalQueAnswerList") {
        let host = window.location.host;
        let protocal = this.$isHttps ? "https://" : "http://";
        let src = protocal + host + this.AGRIDATA;
        if (curMenu && curMenu.length > 0) {
          this.pageVisitRecord(curMenu[0].colId, curMenu[0].parentColId, curMenu[0].colName , "2002", "1");
        }
        this.toWebSite(src);
      } else if (name === 'fjjfypt') {
        // 跳转福建金服云平台
        if (curMenu && curMenu.length > 0) {
          this.pageVisitRecord(curMenu[0].colId, curMenu[0].parentColId, curMenu[0].colName , "2002", "1");
          const src = curMenu[0].colDesc;
          if (isAbsPath(src)) {
            this.toWebSite(src);
          }
        }
      } else {
        if (curMenu && curMenu.length > 0) {
          this.pageVisitRecord(curMenu[0].colId, curMenu[0].parentColId, curMenu[0].colName , "2001", "1");
        }
        if (this.routeName !=  name) {
          this.$router.push({ name: name });
        }
      }
    },
    command(params) {
      if (params) {
        this.toWebSite(params);
      }
    },
    search() {
      this.pageVisitRecord(this.SITESTR + "0ab4b97878c00000", "", "高级检索" , "2001", "4");
      this.$router.push({
        name: "searchResult",
      });
    },
    goTo() {
      window.location.href = "https://beian.miit.gov.cn";
    },
    goBanner(link) {
      if (link && link !== "") {
        window.open(link, "_blank");
      }
    }
  },
};
</script>
<style lang="scss">
.noData {
  height: 200px;
  width: 100%;
  color: #d7d7d7;
  font-size: 24px;
  text-align: center;
  margin-top: 100px;
}
.contentTab {
  &.el-tabs {
    .el-tabs__header {
      .el-tabs__item {
        font-size: 16px;
        &:hover {
          color: #1ca868;
        }
        &.is-active {
          color: #1ca868;
        }
      }
      .el-tabs__active-bar {
        background-color: #1ca868;
      }
    }
  }
}
.el-button--primary,
.el-button--primary.is-active,
.el-button--primary:active {
  background-color: #0079fe !important;
  border-color: #0079fe !important;
}
.el-button--success,
.el-button--success.is-active,
.el-button--success:active {
  background-color: #1ca868 !important;
  border-color: #1ca868 !important;
}
.container {
  .title {
    text-align: center;
    font-size: 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid #cccccc;
  }
  .middle-content {
    width: 100%;
    height: 35px;
    margin: auto;
    line-height: 35px;
    color: #484848;
    text-align: center;
    span {
      padding: 0 20px;
      font-size: 14px;
    }
    margin-bottom: 10px;
    border-bottom: 1px solid #cccccc;
  }
}
.el-input {
  .el-input__inner:focus {
    border-color: #1ca868;
  }
}
.el-select {
  .el-input.is-focus {
    .el-input__inner {
      border-color: #1ca868 !important;
    }
  }
  .el-select-dropdown__item.selected {
    color: #1ca868;
  }
}
.el-radio {
  .el-radio__input.is-checked {
    .el-radio__inner {
      border-color: #1ca868 !important;
      background-color: #1ca868 !important;
      &:hover {
        border-color: #1ca868 !important;
      }
    }
  }
  .el-radio__label {
    color: #1ca868 !important;
  }
}
</style>
<style lang="scss">
.el-form-item.fileUploadItem {
  .el-form-item__content {
    line-height: 0px;
  }
}
.ql-editor {
  font-size: 20px;
  line-height: 2;
  pre {
    text-wrap: balance;
  }
  img {
    max-width: 1100px;
    cursor: default;
  }
  .ql-video {
    max-width: 1100px;
  }
  .ql-size-12px {
    font-size: 12px;
  }
  .ql-size-16px {
    font-size: 16px;
  }
  .ql-size-18px {
    font-size: 18px;
  }
  .ql-size-20px {
    font-size: 20px;
  }
  .ql-size-24px {
    font-size: 24px;
  }

  .ql-size-28px {
    font-size: 28px;
  }
  .ql-size-32px {
    font-size: 32px;
  }
  .ql-size-36px {
    font-size: 36px;
  }
  .ql-size-40px {
    font-size: 40px;
  }
}
.ql-font-SimSun {
  font-family: "SimSun";
}
.ql-font-SimHei {
  font-family: "SimHei";
}
.ql-font-Microsoft-YaHei {
  font-family: "Microsoft YaHei";
}
.ql-font-KaiTi {
  font-family: "KaiTi";
}
.ql-font-FangSong {
  font-family: "FangSong";
}
.ql-font-Arial {
  font-family: "Arial";
}
.ql-font-Times-New-Roman {
  font-family: "Times New Roman";
}
.ql-font-sans-serif {
  font-family: "sans-serif";
}

.quill-editor {
  line-height: normal;
}
.ql-lineHeight {
  margin-left: 0px;
}
.ql-lineHeight::before {
  content: "行间距：";
  position: relative;
  top: 2px;
  left: 8px;
}
.ql-lineHeight .ql-picker-label {
  left: 50px;
  top: -20px;
}
.ql-lineHeight .ql-picker-options {
  left: 50px;
}
.ql-lineHeight-1 {
  line-height: 1;
}
.ql-lineHeight-1-15 {
  line-height: 1.15;
}
.ql-lineHeight-1-5 {
  line-height: 1.5;
}

.ql-lineHeight-2 {
  line-height: 2;
}

.ql-lineHeight-2-5 {
  line-height: 2.5;
}
.ql-lineHeight-3 {
  line-height: 3;
}
.ql-picker.ql-lineHeight .ql-picker-label::before,
.ql-picker.ql-lineHeight .ql-picker-item::before {
  content: "1";
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value="1-5"]::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value="1-5"]::before {
  content: "1.5";
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value="2-5"]::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value="2-5"]::before {
  content: "2.5";
}
.ql-picker.ql-lineHeight .ql-picker-label[data-value="2"]::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value="2"]::before {
  content: "2";
}

.ql-picker.ql-lineHeight .ql-picker-label[data-value="3"]::before,
.ql-picker.ql-lineHeight .ql-picker-item[data-value="3"]::before {
  content: "3";
}

.loadingClass {
  .el-loading-spinner {
    left: calc(50% - 100px);
    margin-top: -21px;
    width: 200px;
    background-color: rgba($color: #fff, $alpha: 1) !important;
    i,
    .el-loading-text {
      font-size: 18px;
    }
  }
}
.el-message {
  font-size: 18px;
  .el-message__content {
    font-size: 18px;
  }
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
}
textarea {
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
<style lang="scss" scoped>
#app {
  max-width: 1920px;
  min-width: 1200px;
  margin: 0 auto;
}
.header {
  .header__top-line {
    width: 1200px;
    margin: 0 auto;
    height: 90px;
    background-color: #fff;
    .left {
      float: left;
      text-align: center;
      margin-top: 10px;
      .logo {
        color: #1ca868;
        font-size: 46px;
        letter-spacing: 4px;
        font-weight: 600;
      }
      .url {
        color: #979797;
        font-size: 20px;
        letter-spacing: 1px;
      }
    }
    .right {
      float: right;
      color: #333;
      font-size: 16px;
      margin-right: 23px;
      line-height: 53px;
      margin-top: 30px;
      .card {
        z-index: 9990;
        height: 35px;
        display: inline-block;
        width: 120px;
        &.cityPortal {
          position: relative;
        }
        .more {
          border: 1px solid #bfd6c7;
          background-color: #1ca868;
          border-radius: 5px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #fff;
          &:hover {
            border: 1px solid #1ca868;
            cursor: pointer;
          }
        }
      }
      .el-dropdown {
        display: inline-block;
        color: #000;
        cursor: pointer;
        font-size: 16px;
        line-height: 20px;
      }
      .searchResult {
        margin-left: 10px;
        width: 300px;
        display: inline-block;
      }
    }
  }
  .header__carousel {
    height: 340px;
    min-width: 1200px;
  }
  .header__menu {
    width: 1200px;
    margin: 0 auto;
    .el-menu {
      display: flex;
      justify-content: center;
      height: 50px;
      border-bottom: none;
      .el-menu-item {
        border-bottom: none;
        height: 100%;
        line-height: 50px;
        font-size: 20px;
        padding: 0 2.6%;
        &.is-active {
          background-color: #fff !important;
        }
      }
    }
  }
}
.el-main {
  padding: 0;
  min-height: 450px;
  min-width: 1200px;
}
.noline {
  text-decoration: none;
}
.footer {
  min-width: 1200px;
  background: #181e24;
  margin-top: 48px;
  font-size: 16px;
  color: #cbcdd1;
  text-align: center;
  line-height: 30px;
  padding-top: 20px;
  span + span {
    margin: 40px;
  }
}
</style>
